import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Navigate, Routes } from 'react-router-dom';
import { Container, InstanceName, AccountNavigation, AccountTab } from './styles';
import { MyProfile } from './components';
import ApiKeys from './components/api-keys';
import { usePageTitle } from '../../context/navigationContext';
import { useUi } from '../../context/ui.context';

const AccountSettings: FC = () => {
  const [t] = useTranslation();
  const { setSmallBar } = useUi();
  usePageTitle(t('ACCOUNT_SETTINGS'));

  useEffect(() => {
    const viewport = window.matchMedia('(max-width: 640px)');
    const collapseSidebar = () => {
      if (viewport.matches) setSmallBar(true);
    };
    collapseSidebar();
    viewport.addEventListener('change', collapseSidebar);
    return () => viewport.removeEventListener('change', collapseSidebar);
  }, [setSmallBar]);

  return (
    <Container>
      <InstanceName>{t('ACCOUNT_SETTINGS')}</InstanceName>
      <AccountNavigation aria-label={t('ACCOUNT_SETTINGS')}>
        <AccountTab to="my-profile">{t('MY_PROFILE')}</AccountTab>
        <AccountTab to="api-keys">{t('API_KEYS_TITLE')}</AccountTab>
      </AccountNavigation>
      <Routes>
        <Route path="/" element={<Navigate replace to="my-profile" />} />
        <Route path="/my-profile" element={<MyProfile />} />
        <Route path="/api-keys" element={<ApiKeys />} />
      </Routes>
    </Container>
  );
};

export default AccountSettings;
